export const CareerGoalsTitleType = {
  budget: "financial goals",
  short: "career goals (short term)",
  long: "career goals (long term)",
  custom: "custom goals",
};

export const getTotalCareerGoals = (goals) =>
  // eslint-disable-next-line unicorn/no-array-reduce
  Object.values(goals ?? {}).reduce(
    (acc, current) => acc + (current?.length ?? 0),
    0
  );
